import { connect } from "react-redux";

import BaseComponent from "@js/components/base_component.jsx";
import { setUserInput, doSearch, doDelete, doDeleteConfirmed, doDeleteCancel } from "@js/actions/suppressed_address_search/actions.js";
import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";
import { Modal, ModalBody } from "@modal";

class SuppressedAddressSearchInner extends BaseComponent {

  render() {
    return (
      <div>
        <ul className="form-fields">
          <li className="form-field">
            <label className="string" htmlFor="address">{ t("phrases.email_md5_or_sha256") }</label>
            <input type="text" id="address" className="string" onKeyUp={ this._onChangeInput } onChange={ this._onChangeInput } style={{ width: "475px" }} />
            <a className="button" id="address-button" href="#" onClick={ this._onSubmit } style={{ marginLeft: "10px" }}>{ t("buttons.search") }</a>

            {
              this.props.searching && (
                <div>
                  <span className="quick-info success">{ t("phrases.searching") }</span>
                </div>
              )
            }

            {
              this.props.error && (
                <div>
                  <span className="quick-info failure">{ this.props.error }</span>
                </div>
              )
            }
          </li>
        </ul>

        {
          this.props.results && (
            <div>
              <br/>
              { this._renderResultsTable(this.props.results) }
            </div>
          )
        }

        {
          this.props.confirmDelete && (
            this._renderConfirmDeleteModal()
          )
        }
      </div>
    );
  }

  _onChangeInput(e) {
    e.stopPropagation();
    e.preventDefault();

    if ( e.keyCode == 13 ) {
      this.props.dispatch(doSearch());
    } else {
      this.props.dispatch(setUserInput(e.target.value));
    }
  }

  _onSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    this.props.dispatch(doSearch());
  }

  _onDelete(id, name) {
    return (e) => {
      e.stopPropagation();
      e.preventDefault();

      this.props.dispatch(doDelete(id, name));
    };
  }

  _renderResultsTable(results) {
    return (
      <div className="suppressed-address-search-results data-table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th width="125">{ t("simple_form.labels.suppressed_address.date_added") }</th>
              <th>{ t("simple_form.labels.suppressed_address.email") }</th>
              <th width="300">{ t("simple_form.labels.suppressed_address.user") }</th>
              <th width="150">{ t("simple_form.labels.suppressed_address.address_type") }</th>
              <td width="150"></td>
            </tr>
          </thead>
          <tbody>
            {
              results.map((result, ii) => (
                <tr key={ ii }>
                  <td>{ result.date_added }</td>
                  <td style={{ wordBreak: "break-all" }}>{ result.email }</td>
                  <td>{ result.suppressed_by ? result.suppressed_by : <span>&mdash;</span> }</td>
                  <td>{ t("suppressed_address_types." + result.type) }</td>
                  <td className="actions">
                    <a href={ Routes.edit_suppressed_address_path({ id: result.id }) } className="edit-button action-button button" target="_blank"><i className="ir"> Edit</i></a>
                    <a href="#" id={`address-delete-${result.id}`} onClick={ this._onDelete(result.id, result.email) } className="trash-button action-button button" rel="nofollow"><i className="ir"> Delete</i></a>
                  </td>
                </tr>
              ))
            }
            {
              results.length == 0 && (
                <tr>
                  <td colSpan="5">
                    { t("empty_table.suppressed_address_search") }
                  </td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>
    );
  }

  _renderConfirmDeleteModal() {
    return (
      <Modal
        title="Delete Suppressed Address"
        onCancel={() => this.props.dispatch(doDeleteCancel())}
        onSave={() => this.props.dispatch(doDeleteConfirmed())}
        saveText={ t("buttons.delete") }
        dangerous={ true }
        loading={ this.props.deleteStarted }
      >
        <ModalBody>Are you sure you want to delete &ldquo;{ this.props.confirmDeleteName }&rdquo;?</ModalBody>
      </Modal>
    );
  }

}

const mapStateToProps = (state) => ({
  suppressionListID: state.suppressionListID,
  searching:         state.searching,
  error:             state.error,
  results:           state.results,
  confirmDelete:     state.confirmDelete,
  confirmDeleteID:   state.confirmDeleteID,
  confirmDeleteName: state.confirmDeleteName,
  deleteStarted:     state.deleteStarted,
});

export default connect(mapStateToProps)(SuppressedAddressSearchInner);
